import apiClient from "../common/apiClient";

/**
 * Upload ảnh chat (field name `image` — khớp backend multer).
 * @returns {Promise<{ data?: { imageUrl, filename, originalname } }>}
 */
export async function uploadChatImage(file) {
  const fd = new FormData();
  fd.append("image", file);
  return apiClient.post("/upload/image", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

/**
 * Upload file tài liệu (field name `file` — khớp backend multer).
 * UI KHÔNG đọc/parse nội dung file, chỉ upload lấy URL để gửi cho AI xử lý.
 * @returns {Promise<{ data?: { fileUrl, filename, originalname, mimetype, size } }>}
 */
export async function uploadChatFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  return apiClient.post("/upload/file", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

/** URL tuyệt đối để model / markdown hiển thị được ảnh */
export function toAbsoluteUploadUrl(relativeOrAbsolute) {
  if (!relativeOrAbsolute) return "";
  if (/^https?:\/\//i.test(relativeOrAbsolute)) return relativeOrAbsolute;
  const base = apiClient.defaults.baseURL || "";
  const origin = base.replace(/\/api\/v2\/?$/i, "");
  const path = relativeOrAbsolute.startsWith("/")
    ? relativeOrAbsolute
    : `/${relativeOrAbsolute}`;
  return `${origin}${path}`;
}
